module.exports = __webpack_public_path__ + "img/soporte.1b600acb.jpg";